module.exports = __webpack_public_path__ + "static/media/kevin.72a2dc8b.jpg";